import React from 'react';
import { CalendarSolid } from '@/components/Icons/CalendarSolid';
import { AbsenceResultChipKind } from '@/types/components';
import { tv } from '@/utils/tv';

interface Props {
  kind: AbsenceResultChipKind;
  label: string;
}

const chip = tv({
  base: 'inline-flex items-center gap-1 rounded-xl px-2 py-[2px] text-caption-12',
  variants: {
    kind: {
      [AbsenceResultChipKind.Info]: 'bg-info-surface text-primary',
      [AbsenceResultChipKind.Warning]: 'bg-warning-surface text-warning',
      [AbsenceResultChipKind.Error]: 'bg-destructive-surface text-destructive',
    },
  },
});

export const AbsenceResultChip: React.FC<Props> = ({ kind, label }) => (
  <span className={chip({ kind })}>
    {kind !== AbsenceResultChipKind.Error && (
      <CalendarSolid className="size-4" />
    )}
    {label}
  </span>
);
